import React, {Component} from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { formatDateTime } from "../../api";
import DBDownloadItem from './dbDownloadItem';

class DBDownloads extends Component {
    render(){
            const { item } = this.props;
            const downloads = [];

            item.orders.forEach(order => {
                const date = order.createdAt;
                order.items.forEach(orderItem => {
                    const title = orderItem.title;
                    if (orderItem.downloads && orderItem.downloads.length > 0) {
                        downloads.push ({ date: date, title: title, downloads: orderItem.downloads})
                    }
                })
            })

            return (                                
                <div className="dashboard-right">
                    <div className="dashboard">
                        <div className="page-title">
                            <h2>My Downloads</h2>
                        </div>
                        <div className="welcome-msg">
                            <p>These are the files that you have available to download. </p><br/>
                        </div>
                        <div className="box-account box-info">
                            <div className="row">
                                <div className="col-sm-12">
                                    <ReactTable
                                        data={downloads}
                                        columns={[{
                                            Header: 'Product',
                                            accessor: 'title',
                                          },{
                                            Header: 'Date',
                                            accessor: 'date', // String-based value accessors!
                                            Cell: props => <span>{formatDateTime(new Date(props.value))}</span>
                                          }]}                                        
                                        defaultPageSize={10}
                                        showPagination={true}
                                        SubComponent={row => {
                                            return (
                                                <DBDownloadItem downloadItems={row.original.downloads} />
                                            )}}
                                    />
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
        )
    }
}

export default DBDownloads

